import { useMutation, useQuery } from '@apollo/client'
import PortalForm from '@medical/pages/staff/Portal/components/PortalForm'
import { useCustom } from '@medical/provider/context'
import Router from '@medical/routes/router'
import React, { useEffect } from 'react'
import { ErrorComponent, ProgressSpinner } from '@medical/components'
import {
  STAFF_CREATE_PORTAL,
  STAFF_UPDATE_PORTAL,
  STAFF_DELETE_PORTAL,
} from '@medical/constant/permissions'
import { checkStaffPermission } from '@medical/libs'
import { CREATE_ACTIVITY } from '@medical/pages/doctor/AvailableShift/AvailableShift.graphql'
import { CREATE_PORTAL, CATEGORY_QUERY } from './PortalCreate.graphql'

const PortalCreate = ({ history }) => {
  const [{ i18n, popup }] = useCustom()
  const isCreatePermitted = checkStaffPermission({
    functionName: STAFF_CREATE_PORTAL,
  })
  const isDeletePermitted = checkStaffPermission({
    functionName: STAFF_DELETE_PORTAL,
  })
  const isUpdatePermitted = checkStaffPermission({
    functionName: STAFF_UPDATE_PORTAL,
  })
  const [staffCreateActivity] = useMutation(CREATE_ACTIVITY)
  const [createPortal] = useMutation(CREATE_PORTAL)
  const {
    loading: largeCategoryLoading,
    error: largeCategoryError,
    data: largeCategoryData,
    refetch: largeCategoryRefetch,
  } = useQuery(CATEGORY_QUERY, {
    variables: {
      where: {
        titleType: 'LARGE_TITLE',
      },
      orderBy: 'largeTitle_ASC',
    },
  })
  const {
    loading: mediumCategoryLoading,
    error: mediumCategoryError,
    data: mediumCategoryData,
    refetch: mediumCategoryRefetch,
  } = useQuery(CATEGORY_QUERY, {
    variables: {
      where: {
        titleType: 'MEDIUM_TITLE',
      },
      orderBy: 'mediumTitle_ASC',
    },
  })
  useEffect(() => {
    largeCategoryRefetch()
    mediumCategoryRefetch()
  })
  if (largeCategoryLoading || mediumCategoryLoading) return <ProgressSpinner />
  if (largeCategoryError || mediumCategoryError)
    return <ErrorComponent error={largeCategoryError || mediumCategoryError} />

  const onSubmit = async (
    values,
    { setSubmitting, resetForm, setFieldValue }
  ) => {
    try {
      await createPortal({
        variables: {
          portalId: '',
          largeTitle: values.largeTitle,
          mediumTitle: values.mediumTitle,
          smallTitle: values.smallTitle.trim(),
          titleType: 'SMALL_TITLE',
          content: values.content.trim(),
        },
      })
      staffCreateActivity({
        variables: {
          activity: 'STAFF_CREATE_PORTAL',
        },
      })
      popup.success('作成しました。')
      setSubmitting(false)
      resetForm()
      history.push({
        pathname: Router.staffPortals,
      })
    } catch (error) {
      popup.error(error)
      setFieldValue('confirm', false)
      setSubmitting(false)
    }
  }

  return (
    <>
      <PortalForm
        portal={{}}
        largeCategory={largeCategoryData && largeCategoryData.portals}
        mediumCategory={mediumCategoryData && mediumCategoryData.portals}
        onSubmit={onSubmit}
        isCreatePermitted={isCreatePermitted}
        isUpdatePermitted={isUpdatePermitted}
        isDeletePermitted={isDeletePermitted}
      />
    </>
  )
}

export default PortalCreate
